import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TransitionProps } from 'react-transition-group/Transition'

interface Notification {
  id: string
  message: string
  severity: 'success' | 'info' | 'warning' | 'error'
  autoHideDuration?: number
  transition?: React.ComponentType<
    TransitionProps & {
      children: React.ReactElement<any, any>
    }
  >
}

interface NotificationState {
  notifications: Notification[]
  appLoading: boolean
  currentNotification: Notification | null
}

const initialState: NotificationState = {
  notifications: [],
  appLoading: false,
  currentNotification: null,
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    pushNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.push(action.payload)
      if (!state.currentNotification) {
        state.currentNotification = state.notifications.shift() || null
      }
    },
    removeCurrentNotification: (state) => {
      state.currentNotification = state.notifications.shift() || null
    },
    setAppLoading: (state, action: PayloadAction<boolean>) => {
      state.appLoading = action.payload
    },
  },
})

export const { pushNotification, removeCurrentNotification, setAppLoading } =
  notificationSlice.actions

export default notificationSlice.reducer
